import { useCurrency } from '@/contexts/CurrencyContext';
import { formatCurrency, getCurrencyByCode, DEFAULT_CURRENCY } from '@/config/currency';

/**
 * Hook to format currency values using the current currency setting
 * Falls back to default currency if CurrencyProvider is not available
 */
export function useCurrencyFormat() {
  let currency: string;
  let currencyConfig: ReturnType<typeof getCurrencyByCode>;

  try {
    const context = useCurrency();
    currency = context.currency;
    currencyConfig = context.currencyConfig;
  } catch (error) {
    // Fallback if CurrencyProvider is not available
    currency = DEFAULT_CURRENCY;
    currencyConfig = getCurrencyByCode(DEFAULT_CURRENCY)!;
  }

  const format = (amount: number): string => {
    return formatCurrency(amount, currency);
  };

  return {
    format,
    currency,
    symbol: currencyConfig.symbol,
    code: currencyConfig.code,
  };
}
